/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import dayjs from "dayjs";
import React from "react";
import { atom } from "recoil";
import Tag from "../../Tag";
import { ITagRow } from "./Tags";

interface TableProps {
  check: boolean;
}

const Row = styled.div<TableProps>`
  display: grid;
  border: 1px solid;
  border-color: ${(props) => (props.check ? "#FB972E" : "#f8f8f8")};
  background-color: ${(props) =>
    props.check ? "rgb(251, 151, 46, 0.05)" : "#f8f8f8"};
  grid-template-rows: 1fr;
  align-items: center;
`;

const GridRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 180px 1fr 20px;
  grid-column-gap: 15px;
  padding: 15px;
  align-items: center;
  height: 60px;
`;

const TableTitle = styled.div`
  color: #2f2f2f;
  display: flex;
  font-size: 16px;
  align-items: center;
  overflow: hidden;
`;

const Name = styled.span`
  max-width: 100%;
  margin-left: 10px;
  letter-spacing: 0px;
  color: #2f2f2f;
  font-weight: 600;
`;

const TextCss = css`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
`;

interface Props {
  row: ITagRow;
  isChecked: boolean;
  handleCheck: () => void;
  handleRemove: () => void;
}

export default function TagsTableRow(props: Props): JSX.Element {
  const { row, handleCheck, isChecked, handleRemove } = props;

  return (
    <Row
      check={isChecked}
      css={css`
        margin-top: 10px;
      `}
    >
      <GridRow>
        {/* <StyledCheckBox check={isChecked} handleCheck={handleCheck} /> */}
        <TableTitle>
          <Name
            css={css`
              ${TextCss}
            `}
          >
            <Tag
              tag={row as any}
              preserveSystemTags
              deleteTag={() => handleRemove()}
            />
          </Name>
        </TableTitle>

        <TableTitle
          css={css`
            ${TextCss}
            font-weight: bold;
          `}
        >
          {row.category}
        </TableTitle>

        <TableTitle style={{ marginLeft: "auto" }}>
          {dayjs(row.appliedAt).format("MMM D, YYYY [@] h:mm a")}
        </TableTitle>
      </GridRow>
    </Row>
  );
}
